import { render, staticRenderFns } from "./PFormInputHour.vue?vue&type=template&id=25d8b128&scoped=true&"
import script from "./PFormInputHour.vue?vue&type=script&lang=ts&"
export * from "./PFormInputHour.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputHour.vue?vue&type=style&index=0&id=25d8b128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8b128",
  null
  
)

export default component.exports